/**
 * @flow
 * @relayHash ddc421d1792f231e7acc7237940a1ba7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type JobRequestsAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query JobRequestsAdminQuery(
  $count: Int!
  $cursor: String
  $hasOpenJobOffers: Boolean
  $searchStudent: String
  $status: [JobRequestStatus]
  $requestType: [JobRequestType]
  $studentId: ID
) {
  admin {
    ...JobRequests_admin_1G22uz
  }
}

fragment JobRequests_admin_1G22uz on Admin {
  allStudents(first: 10, fuzzy: $searchStudent) {
    edges {
      node {
        id
        user {
          email
          id
        }
        firstname
        lastname
      }
    }
  }
  allJobRequests(first: $count, after: $cursor, status: $status, requestType: $requestType, student: $studentId, hasOpenJobOffers: $hasOpenJobOffers) {
    edges {
      node {
        __typename
        id
        status
        requestType
        student {
          firstname
          lastname
          profilePictureThumbnailUri
          id
        }
        grade {
          name
          id
        }
        subject {
          name
          id
        }
        createdAt
        openJobOffersCount
        sessions {
          timeSlots {
            id
            startDate
            duration {
              hours
              minutes
              id
            }
          }
          id
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasOpenJobOffers",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "searchStudent",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[JobRequestStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "requestType",
        "type": "[JobRequestType]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "studentId",
        "type": "ID",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobRequestsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobRequests_admin",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "JobRequestsAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasOpenJobOffers",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "searchStudent",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[JobRequestStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "requestType",
        "type": "[JobRequestType]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "studentId",
        "type": "ID",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "JobRequestsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "fuzzy",
                "variableName": "searchStudent",
                "type": "String"
              }
            ],
            "concreteType": "StudentConnection",
            "name": "allStudents",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "StudentEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Student",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "lastname",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasOpenJobOffers",
                "variableName": "hasOpenJobOffers",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "requestType",
                "variableName": "requestType",
                "type": "[JobRequestType]"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[JobRequestStatus]"
              },
              {
                "kind": "Variable",
                "name": "student",
                "variableName": "studentId",
                "type": "ID"
              }
            ],
            "concreteType": "JobRequestConnection",
            "name": "allJobRequests",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "JobRequestEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "JobRequest",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "requestType",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Student",
                        "name": "student",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "firstname",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "lastname",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "profilePictureThumbnailUri",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Grade",
                        "name": "grade",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Subject",
                        "name": "subject",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "openJobOffersCount",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "JobRequestSession",
                        "name": "sessions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlot",
                            "name": "timeSlots",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "startDate",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Duration",
                                "name": "duration",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "hours",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "minutes",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "id",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasOpenJobOffers",
                "variableName": "hasOpenJobOffers",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "requestType",
                "variableName": "requestType",
                "type": "[JobRequestType]"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[JobRequestStatus]"
              },
              {
                "kind": "Variable",
                "name": "student",
                "variableName": "studentId",
                "type": "ID"
              }
            ],
            "handle": "connection",
            "name": "allJobRequests",
            "key": "JobRequests_allJobRequests",
            "filters": [
              "status",
              "requestType",
              "student",
              "hasOpenJobOffers"
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query JobRequestsAdminQuery(\n  $count: Int!\n  $cursor: String\n  $hasOpenJobOffers: Boolean\n  $searchStudent: String\n  $status: [JobRequestStatus]\n  $requestType: [JobRequestType]\n  $studentId: ID\n) {\n  admin {\n    ...JobRequests_admin_1G22uz\n  }\n}\n\nfragment JobRequests_admin_1G22uz on Admin {\n  allStudents(first: 10, fuzzy: $searchStudent) {\n    edges {\n      node {\n        id\n        user {\n          email\n          id\n        }\n        firstname\n        lastname\n      }\n    }\n  }\n  allJobRequests(first: $count, after: $cursor, status: $status, requestType: $requestType, student: $studentId, hasOpenJobOffers: $hasOpenJobOffers) {\n    edges {\n      node {\n        __typename\n        id\n        status\n        requestType\n        student {\n          firstname\n          lastname\n          profilePictureThumbnailUri\n          id\n        }\n        grade {\n          name\n          id\n        }\n        subject {\n          name\n          id\n        }\n        createdAt\n        openJobOffersCount\n        sessions {\n          timeSlots {\n            id\n            startDate\n            duration {\n              hours\n              minutes\n              id\n            }\n          }\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/job/__generated__/JobRequestsAdminQuery.graphql.js